module.exports = __webpack_public_path__ + "static/media/x.38341b85.png";